import React, {forwardRef, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useTheme} from "@material-ui/core";
import {Map, TileLayer, ZoomControl} from 'react-leaflet';
import leafletShadow from 'leaflet/dist/images/marker-shadow.png';
import Leaflet from 'leaflet';
import defaultRetinaIcon from 'leaflet/dist/images/marker-icon-2x.png';
import defaultIcon from 'leaflet/dist/images/marker-icon.png';

//this makes marker possible to appear
delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: defaultRetinaIcon,
    iconUrl: defaultIcon,
    // iconRetinaUrl: mapPin,
    // iconUrl: mapPin,
    shadowUrl: leafletShadow,
});

export const defaultCenter = {
    lat: 52.288851,
    lng: 20.868763
};

const mapLightAttr = '<a href="https://osm.org/copyright">OpenStreetMap</a> contributors';
const mapLightUrl = "https://mapa.qsafe24.com.pl/osm/{z}/{x}/{y}.png";
const mapDarkUrl = "https://mapa.qsafe24.com.pl/osm/{z}/{x}/{y}.png";
const mapDarkAttr = '<a href="https://osm.org/copyright">OpenStreetMap</a> contributors';

const MapComponent = forwardRef((props, ref) => {
    const {children, onZoomChange, onCenterChange, onDragChange, onDblClickChange, onZoomEnd} = props;
    const theme = useTheme();
    const [mapAttr, setMapAttr] = useState(mapLightAttr);
    const [mapUrl, setMapUrl] = useState(mapLightUrl);

    useEffect(() => {
        switch (theme.palette.type) {
            case "dark":
                setMapAttr(mapDarkAttr);
                setMapUrl(mapDarkUrl);
                break;
            default:
                setMapAttr(mapLightAttr);
                setMapUrl(mapLightUrl);
                break;
        }
    }, [theme.palette.type]);

    return (
        <Map
            ref={ref}
            animate={true}
            duration={1}
            defaultCenter={defaultCenter}
            maxZoom={17}
            keyboard={false}
            zoomControl={false}
            onzoomend={() => {
                onZoomChange && onZoomChange(ref.current.leafletElement.getZoom());
                onZoomEnd && onZoomEnd();
            }}
            onmoveend={() => {
                onCenterChange && onCenterChange(ref.current.leafletElement.getCenter());
            }}
            ondrag={() => onDragChange && onDragChange()}
            ondblclick={() => onDblClickChange && onDblClickChange()}
            {...props}
            scrollWheelZoom={true}
        >
            <ZoomControl position="topright"/>
            <TileLayer
                attribution={mapAttr}
                url={mapUrl}
            />
            {children}
        </Map>
    );
});

MapComponent.displayName = "MapComponent";

MapComponent.propTypes = {
    children: PropTypes.any,
    onZoomChange: PropTypes.func,
    onCenterChange: PropTypes.func,
    onDragChange: PropTypes.func,
    onDblClickChange: PropTypes.func,
    onZoomEnd: PropTypes.func,
};

export default MapComponent;


